/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Table_KeyInputs */



/**
* | output |
* | --- |
* | "Key" |
*
* @param {Options_Api_Keys_Table_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_table_key = /** @type {((inputs?: Options_Api_Keys_Table_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Table_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schlüssel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ключ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Llave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("钥匙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("鍵")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चाबी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chave")
	return /** @type {LocalizedString} */ ("Key")
});